import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: "Responsive Landing Page",
      description: "A modern landing page built during my internship.",
      technologies: ["HTML", "CSS", "JavaScript"]
    },
    {
      title: "Personal Portfolio Template",
      description: "My own portfolio template for developers, focused on simplicity and clean code.",
      technologies: ["HTML", "CSS", "JavaScript"]
    }
  ];

  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="section-title">Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tech">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;